import React from 'react';
import {
    Building2, Car, Boxes, FileSearch, Landmark, CircuitBoard,
    BriefcaseBusiness, Globe, UserCog, Handshake, TrendingUp, ArrowRightLeft, LineChart,
    ShieldCheck, Lock, MapPin, Globe2, FileText, Clock,
} from 'lucide-react';

const MAP = {
    Building2, Car, Boxes, FileSearch, Landmark, CircuitBoard,
    BriefcaseBusiness, Globe, UserCog, Handshake, TrendingUp, ArrowRightLeft, LineChart,
    ShieldCheck, Lock, MapPin, Globe2, FileText, Clock,
};

export const ServiceIcon = ({ name, className = 'h-5 w-5' }) => {
    const Cmp = MAP[name] || BriefcaseBusiness;
    return <Cmp className={className} strokeWidth={1.4} />;
};

export default ServiceIcon;
